// Local
import Animate from './partials/animate';
import UploadControl from "./partials/upload-control";
import FieldsetRepeatable from "./partials/fieldset-repeatable";
import FaqByCategory from "./partials/faq-by-category";
import Collapsable from "./partials/collapsable";
import ServiceList from "./partials/service-list";
import Header from "./partials/header";
import TeamList from "./partials/team-list";

window.initDom = ($wrapper) => {
    console.debug($wrapper, 'init');
    $wrapper.querySelectorAll('[data-animate]').forEach($item => (new Animate($item)));
    $wrapper.querySelectorAll('[data-upload]').forEach($el => new UploadControl($el));
    $wrapper.querySelectorAll('[data-form-repeatable]').forEach($el => new FieldsetRepeatable($el));
    $wrapper.querySelectorAll('[data-faq-list-by-category]').forEach($el => new FaqByCategory($el));
    $wrapper.querySelectorAll('[data-service-list]').forEach($el => new ServiceList($el));
    $wrapper.querySelectorAll('[data-collapsable]').forEach($el => new Collapsable($el));
    $wrapper.querySelectorAll('[data-team-list]').forEach($el => new TeamList($el));
    $wrapper.querySelectorAll('[data-header]').forEach($el => new Header($el));
    $wrapper.querySelectorAll('[data-form]').forEach(async ($el) => {
        const Form = await import('./partials/form');
        (new Form.default($el));
    });
}


(function() {
})();

document.addEventListener('DOMContentLoaded', () => {
    window.initDom(document);
});